import { useQuery } from "@tanstack/react-query";
import { useToast } from "../../view/components/ui/use-toast";
import { useEffect } from "react";
import { selfHireService } from "../services/selfHireService";

export const useGetPublicUser = (linkName: string) => {
  const { isError, data, isLoading } = useQuery({
    queryKey: ["publicUser", linkName],
    queryFn: async () => selfHireService.getPublicUser(linkName),
    enabled: !!linkName,
  });

  const { toast } = useToast();

  useEffect(() => {
    if (isError) {
      toast({
        variant: "destructive",
        title: "Erro ao carregador os dados, tente novamente mais tarde!",
      });
    }
  }, [isError, toast]);

  return {
    isLoading,
    data,
  };
};
